import React from 'react';
import { Search, FileText, Calendar, CheckCircle } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    id: 1,
    icon: <Search className="w-10 h-10 text-amber-600 mb-4" data-id="element-198" />,
    title: 'Search Jobs',
    description: 'Browse through hundreds of catering jobs that match your skills and experience.'
  }, {
    id: 2,
    icon: <FileText className="w-10 h-10 text-amber-600 mb-4" data-id="element-199" />,
    title: 'Apply Online',
    description: 'Submit your application with just a few clicks. Upload your resume and cover letter.'
  }, {
    id: 3,
    icon: <Calendar className="w-10 h-10 text-amber-600 mb-4" data-id="element-200" />,
    title: 'Interview',
    description: 'Schedule and prepare for interviews with top catering companies and restaurants.'
  }, {
    id: 4,
    icon: <CheckCircle className="w-10 h-10 text-amber-600 mb-4" data-id="element-201" />,
    title: 'Get Hired',
    description: 'Accept job offers and start your new career in the catering industry.'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center mb-16" data-id="element-204">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-205">How It Works</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-206">
            Finding your dream job in the catering industry has never been
            easier
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-207">
          {steps.map(step => <div key={step.id} className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-208">
              <div className="flex justify-center" data-id="element-209">{step.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-210">
                {step.title}
              </h3>
              <p className="text-gray-600" data-id="element-211">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}